/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";

// actions
import {
  resetChannels,
  resetError,
  getChannels,
  deleteChannel,
} from "../../store/channels/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsis from "../../components/Common/BadgesEllipsis";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Channels = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataChannel,
    dataChannelDelete,
    loadingChannel,
    loadingChannelDelete,
    errorChannel,
    successChannel,
  } = useSelector((state) => state.Channel);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [channelId, setChannelId] = useState("");
  const [channelName, setChannelName] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successChannel && dispatch(resetChannels()) && handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getChannels(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteChannel(channelId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setChannelIdName = (channel) => {
    setChannelId(channel.id);
    setChannelName(channel.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getChannels(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataChannel && dataChannel.paging) {
      if (page < dataChannel.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataChannelDelete && dataChannelDelete.message) {
      showToast("success", t(dataChannelDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successChannel]);

  useEffect(() => {
    if (errorChannel && typeof errorChannel === "object") {
      errorChannel.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorChannel) {
        showToast("error", t(errorChannel));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorChannel]);

  useEffect(() => {
    if (dataChannel !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataChannel]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/channels"
            title={t("Dashboard")}
            breadcrumbItem={t("Channels")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-Channel">
                          <Link to={`/channel`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Channel")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th className="w-50">{t("Name")}</th>
                            <th className="w-25">{t("Skill")}</th>
                            <th className="w-25">{t("Channel")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingChannel ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataChannel &&
                            dataChannel.sources &&
                            dataChannel.sources.length > 0 ? (
                            dataChannel.sources.map((channel, key) => (
                              <tr key={key}>
                                <td className="pl-4">{key + 1}</td>
                                <td className="column-text-overflow-10">
                                  {channel.name}
                                </td>
                                <td>
                                  <BadgesEllipsis
                                    objItems={[channel.skill]}
                                  />
                                </td>
                                <td className="column-text-overflow-10">
                                  {channel.channel}
                                </td>
                                <td className="pl-0">
                                  <Link
                                    to={`/channel/${channel.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id={`edittooltip${key}`}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`edittooltip${key}`}
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  {/* TODO: add custom styles to css file */}
                                  <span style={{ cursor: "pointer" }}>
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id={`deletetooltip${key}`}
                                      onClick={() => {
                                        toggleModal();
                                        setChannelIdName(channel);
                                      }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`deletetooltip${key}`}
                                    >
                                      {t("Delete")}
                                    </UncontrolledTooltip>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingChannelDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the channel")}
                          <strong> {channelName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingChannelDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (channelId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataChannel?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Channels);
